import styles from "./Loader.module.scss";

interface LoaderTypes {
  title: string;
}

export const Loader = ({ title }: LoaderTypes) => {
  return (
    <>
      <div className={styles["backdrop"]}>
        <div className={styles["loader-wrapper"]}>
          <div className={styles["loader"]} />
          <p className={styles["title"]}>{title}</p>
        </div>
      </div>
    </>
  );
};
